<template>
  <div class="add_main">
    <div class="step-box">
      <span :class="{ stepOn: stepIndex >= 0 }">编辑商品信息</span>
      <i class="el-icon-d-arrow-right mglr10" :class="{ stepOn: stepIndex >= 1 }"></i>
      <span :class="{ stepOn: stepIndex >= 1 }">设置发货库存</span>
      <i class="el-icon-d-arrow-right mglr10" :class="{ stepOn: stepIndex >= 2 }"></i>
      <span :class="{ stepOn: stepIndex >= 2 }">设置库存与价格</span>
    </div>
    <el-form v-if="stepIndex == 0" ref="goodDetailForm" :model="goodDetailForm" label-width="140px">
      <el-form-item label="商品归属：">
        <el-select filterable v-model="goodDetailForm.sourceId" placeholder="请选择供应商（可搜索）" clearable
          @change="select_blur_supplier" @clear="clearSupplier">
          <el-option v-for="(item, index) in supplierList" :key="index" :label="item.proSupplierName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品型号：">
        <el-input @input="getModelCode" v-model="goodDetailForm.model" placeholder="请输入商品型号" clearable></el-input>
        <div style="color: red;" v-if="isSearch">* 没有匹配到素材库型号, 将以填写型号为准</div>
        <div style="color: red;" v-if="isCheckModel">很抱歉，因厂家限制要求，该型号价格不得低于￥{{minPrice}}元</div>
      </el-form-item>
      <el-form-item label="" class="modelCodeStyle" v-if="isModelListShow">
        <div class="modelStyle" v-loading="modelListLoading" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="详情搜索中">
          <div @click="setCurrentIndex(item, index)" :class="{ 'active': index == currentIndex }"
            style="cursor: pointer;display:flex;justify-content:space-between;border-bottom:1px solid #DCDFE6;margin-right:10px;"
            v-for="(item, index) in modelList" :key="index">
            <span>型号: {{ item.modelCode }}</span><span style="color:#409EFF;">一键导入</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商品类型：">
        <el-cascader v-model="goodDetailForm.categoryId" :props="{ emitPath: false }" :show-all-levels="true"
          :options="productNavTypeTreeList" placeholder="请选择类型" ref="cascaderCategory"></el-cascader>
      </el-form-item>
      <el-form-item label="商品品牌：">
        <el-autocomplete v-model="goodDetailForm.brandName" :fetch-suggestions="querySearchAsync" placeholder="请选择品牌 可搜索"
          @select="handleSelect"></el-autocomplete>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input v-model="goodDetailForm.name" placeholder="请输入商品名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="商品图片：" style="margin-bottom: 50px">
        <draggable :list="goodDetailForm.pictures" :group="{ sort: true, animation: 500 }">
          <div class="img_box" v-for="(item, index) in goodDetailForm.pictures" :key="index">
            <p class="del_box" @click.stop="handleDelPic(index)">
              <img src="../../../assets/del-icon.png" alt />
            </p>
            <img :src="item.url" alt @click.stop="handleBigPic(item.url)" />
            <p class="set_main">
              <el-button size="mini" @click.stop="setMain(index)">{{
                item.type == 0 ? "主图" : "设为主图"
              }}
              </el-button>
            </p>
          </div>
          <span style="color:#f40000;position: absolute;bottom:0;" v-if="isShowNinePic">最多添加9张</span>
          <el-upload v-if="!isShowNinePic" class="img-uploader" action :show-file-list="false" :auto-upload="false"
            :on-change="handleBusinessPic" multiple>
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </draggable>
      </el-form-item>
      <el-form-item label="商品描述：" style="margin-top: 50px">
        <weditor @catchData="catchDetailData" :isAddEditor="true" v-model="goodDetailForm.introduce"
          :content="goodDetailForm.introduce" :editorHeight="500"></weditor>
      </el-form-item>
      <el-form-item label="补充说明：">
        <el-input type="textarea" v-model="goodDetailForm.serviceContent"
          placeholder="例如：正品保障、7天无理由退换货、15天换货，多个请使用中文顿号分隔"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center;">
          <el-button type="primary" @click="addOrUpdata">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!-- 设置发货库存 -->
    <el-form v-if="stepIndex == 1">
      <el-form-item label="商品规格">
        <el-radio-group v-model="radioSpec" @change="specTemplate">
          <el-radio :label="125">单规格</el-radio>
          <el-radio :label="124">多规格</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radioSpec == 125">
        <el-table id="allsku" border :data="editSkuList1" :row-class-name="(value) => rowClassName(value)">
          <el-table-column label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.propertyValueExtString" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="规格图" align="center">
            <template slot-scope="scope">
              <div class="cell up_img">
                <div class="el_upload_sku">
                  <input class="el_upload_input" @change="handleSkuChange($event, scope.row)" id="el_upload_input"
                    type="file" />
                  <img v-if="scope.row.pictureUrl" :src="scope.row.pictureUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <span class="mask" v-if="scope.row.pictureUrl" @click.stop="delSkuPic(scope.row)">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品编码(选填)" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productCode" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="限购区域" align="center">
            <template slot-scope="scope">
              <div class="flex-wrap">
                <el-select style="width:100%" v-model="scope.row.restrictionAreaGroupId" placeholder="请选择">
                  <el-option :value="0" label="不限购"></el-option>
                  <el-option v-for="(item, index) in areaGroupList" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" @click="renderAreaTree(scope.$index)">添加模板</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot="header" slot-scope="scope">
              <el-button type="primary" icon="el-icon-plus" @click="addSpec1">添加规格</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" @click="deleteSpec1(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item v-if="radioSpec == 124">
        <el-table id="allsku" border :data="allSkuList" :span-method="objectSpanMethod"
          :header-cell-class-name="headerClassName" :row-class-name="(value) => rowClassName(value)">
          <el-table-column label="属性名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.propertyValueExtString" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot-scope="scope">
              <el-table id="allsku" style="border-color:#EBEEF5;" :data="scope.row.children"
                :row-class-name="(value) => rowClassName(value)">
                <el-table-column label="规格名称" align="center">
                  <template slot-scope="scoped">
                    <el-input v-model="scoped.row.propertyValueExtString" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="规格图" align="center">
                  <template slot-scope="scoped">
                    <div class="cell up_img">
                      <div class="el_upload_sku">
                        <input class="el_upload_input" @change="handleSkuChange($event, scoped.row)" id="el_upload_input"
                          type="file" />
                        <img v-if="scoped.row.pictureUrl" :src="scoped.row.pictureUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <span class="mask" v-if="scoped.row.pictureUrl" @click.stop="delSkuPic(scoped.row)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品编码(选填)" align="center">
                  <template slot-scope="scoped">
                    <el-input v-model="scoped.row.productCode" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="限购区域" align="center">
                  <template slot-scope="scoped">
                    <div class="flex-wrap">
                      <el-select v-model="scoped.row.restrictionAreaGroupId" placeholder="请选择限购模板">
                        <el-option :value="0" label="不限购"></el-option>
                        <el-option v-for="(item, index) in areaGroupList" :key="index" :label="item.name"
                          :value="item.id"></el-option>
                      </el-select>
                      <el-button type="primary" @click="renderAreaTree(scope.$index, scoped.$index)">添加模板</el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="" align="center">
                  <template slot="header" slot-scope="scoped">
                    <el-button type="primary" icon="el-icon-plus" @click="addSpec2(scope.row)">添加规格</el-button>
                  </template>
                  <template slot-scope="scoped">
                    <el-button type="text" @click="deleteSpec2(scoped.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center" width="55">
            <template slot-scope="scope">
              <el-button type="text" style="font-size:29px;" icon="el-icon-remove-outline"
                @click="deleteProperty(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:center;font-size:24px;cursor: pointer;margin-top:20px;">
          <i style="color:#3B6FFA;" class="el-icon-circle-plus-outline"></i><span @click="addProperty">添加新属性</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center;">
          <el-button @click="backBtn(0)">上一步</el-button>
          <el-button type="primary" @click="nextStep(2)">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!-- 设置库存与价格 -->
    <el-form v-if="stepIndex == 2">
      <el-form-item>
        <el-table border :data="saleableSkuList" :span-method="objectSpanMethod2">
          <el-table-column label="分销商名称" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.resellerId" placeholder="请选择" clearable @clear="clearSelect(scope.$index)"
                @change="(val) => changeReseller(val, scope.$index)">
                <el-option v-for="(item, index) in resellerList" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="规格名称" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked">{{ scope.row.propertyDisplayExt }}</el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="销售价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <!--    <el-table-column label="商家价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.merchantsPrice" v-if="scope.row.priceType == 1" disabled
                placeholder="请输入"></el-input>
            <el-input v-model="scope.row.merchantsPrice" v-else placeholder="请输入"></el-input> 
            </template>
          </el-table-column>-->
          <el-table-column label="零售价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.retailPrice" v-if="scope.row.priceType == 1" disabled
                placeholder="请输入"></el-input>
              <el-input v-model="scope.row.retailPrice" v-else placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="市场价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.marketPrice" v-if="scope.row.priceType == 1" disabled
                placeholder="请输入"></el-input>
              <el-input v-model="scope.row.marketPrice" v-else placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="销售库存" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.defaultStock" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="区域库存" align="center">
            <template slot-scope="scope">
              <el-button @click="setZone(scope.row, scope.$index)">设置</el-button>
            </template>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot="header" slot-scope="scope">
              <el-button type="primary" icon="el-icon-plus" @click="addReseller()">添加分销商</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" @click="deleteReseller(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center;">
          <el-button @click="backBtn(1)">上一步</el-button>
          <el-button type="primary" @click="saveReseller(false)">保存信息</el-button>
          <el-button type="primary" @click="saveReseller(true)">上架并同步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- 区域限购配置 -->
    <el-dialog id="areaSet" title="区域限购配置" :visible.sync="areaSetFormVisible" v-if="areaSetFormVisible"
      v-model="areaSetFormVisible" :close-on-click-modal="false" width="50%">
      <!-- <div class="col">
        <el-button @click="allSelArea" size="small" type="primary">全选
        </el-button>
        <el-button @click="clearSelArea" size="small" type="danger">清除
        </el-button>
      </div> -->
      <el-form>
        <el-form-item label="模板名称" label-width="80px">
          <el-input v-model="formTemplate.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-tree style="height:400px;overflow:auto;" :data="areaTreeList" show-checkbox node-key="id" ref="tree"
            highlight-current>
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="areaSetFormVisible = false, areaList = []">取消</el-button>
        <el-button type="primary" @click.native="submitAreaSet">提交</el-button>
      </div>
    </el-dialog>
    <!-- 区域库存设置 -->
    <el-dialog title="区域库存设置" :visible.sync="zoneVisible" width="50%">
      <div style="margin-bottom:20px;">
        <el-input v-model="configData" clearable size="small" style="width: 200px;margin-right:20px;"
          placeholder="请输入配置信息"></el-input>
        <el-button type="primary" @click="setConfig" size="small">一键配置</el-button>
        <el-button type="primary" @click="clearConfig" size="small">清空配置</el-button>
        <el-button type="primary" @click="toggleRowExpansion" size="small">全部{{
          isExpansion ? '收缩' : '展开'
        }}
        </el-button>
      </div>
      <div style="height:60vh;overflow-y:auto;">
        <el-table ref="topicTable" :data="zoneData" style="width: 100%;margin-bottom: 20px;" row-key="id" border
          default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <el-table-column prop="areaName" label="省市">
          </el-table-column>
          <el-table-column label="库存">
            <template slot-scope="scope">
              <input type="number" :disabled="scope.row.disabled" v-model="scope.row.stock"
                style="height:35px;padding:0 5px;border:1px solid #eee;border-radius:5px;">
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zoneVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdateSaleArea">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleResult">
      <div>{{ message }}</div>
      <div slot="footer">
        <el-button type="primary" @click="location.reload()">继续添加商品</el-button>
        <el-button type="primary" @click="backSku">返回sku列表</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ProductCreate, //上传商品
  getQiniuToken,
  CategoryGetTree, //获取商品类型
  brandGetAll, //品牌列表
  PropertyGroupGetAll,
  GetProductSkuPreView,
  GetProducDetail,
  BatchCreateAndUpdate,
  ProductSkuGetAll,
  ProductSkuDelete,
  ProductUpdate, //商品编辑
  GetAllSupplier,
  GetKSAXCommodityLibrary, GetSimpleList, ksaxBaseUrl, Product_SpuModelGetDetail
  , PropertyGroupTree,
  ProductSkuCreateMany,
  GetAreaTree,
  RestrictionAreaGroupGetAll,
  ProductSkuGetMany,
  CreateOrUpdateMany,
  GetAllReseller,
  GetSaleableAreas,
  RestrictionAreaGroupCreate,
  CheckProhibited,
  GetProhibitedList
} from "../../../api/api";
import draggable from "vuedraggable";
import weditor from "../../../components/WangEditor";
import { getButtonList } from "../../../promissionRouter";
import maintain from "./components/maintain.vue"
import _ from 'lodash'
import axios from "axios";

export default {
  components: {
    weditor,
    draggable,
    maintain,
  },
  watch: {
    "goodDetailForm.categoryId": {
      handler(n, o) {
        // if (this.$refs['cascaderCategory'].getCheckedNodes()[0].pathNodes){
        if (this.$refs['cascaderCategory'].getCheckedNodes()[0]) {
          let arr = this.$refs['cascaderCategory'].getCheckedNodes()[0].pathNodes;
          this.goodDetailForm.categories = [];
          arr.forEach(x => {
            this.goodDetailForm.categories.push({
              categoryId: x.value,
              categoryName: x.label
            });
          })
          console.log('this.goodDetailForm.categories------', this.goodDetailForm.categories)
        }
      },
      deep: true
    },
    "goodDetailForm.pictures": {
      handler(n, o) {
        if (n.length) {
          this.skuMainpic = n[n.findIndex(val => val.type == 0)].url
        }
        if (n.length >= 9) {
          this.isShowNinePic = true
        } else {
          this.isShowNinePic = false
        }
      },
      deep: true
    }
  },
  data() {
    return {
      stepNum: 0,
      stepIndex: 0,
      isSearch: false,
      afterFlatTypeTree: [],  // tree 转 一维数组数据
      originTypeTree: null,
      checkedModelId: null,
      currentIndex: null,
      isModelListShow: false,
      modelListLoading: false,
      modelList: [],
      propertyName: '',
      // disabledSpu: false,
      disabledSku: false,
      isShowNinePic: false, // 最多显示图片
      dialogMaintain: false,
      dialogCombination: false, // 属性组合展示
      spuId: null,
      qiniuToken: "",
      brandList: [], // 品牌列表
      radio: 1,
      typeShow: true,
      goodDetailForm: {
        categoryId: null,
        categories: [],
        name: null, //商品名称
        model: null, //型号
        brandId: null, //商品品牌
        brandName: '',
        serviceContent: '',
        introduce: '',
        isActive: true,
        pictures: [],
        sourceType: 0,
        sourceId: 0
      },
      propertyList: [], // 属性模板
      skuPreViewList: [], // 规格组合
      checkedSkuList: [],
      productNavTypeTreeList: [], //商品类型
      createSkuList: [], //规格最终生成的数组
      dialogVisible: false,
      dialogImageUrl: "",
      checkList: [],
      supplierList: [],
      skuMainpic: null,
      radioSpec: 125,
      skuNum: 3,
      editSkuList1: [], // 单规格sku数组
      editSkuList2: [],
      allSkuList: [],
      propertySku: [],
      areaSetFormVisible: false,
      areaTreeList: [],
      skuIndex: -1,
      skuChildIndex: -1,
      areaGroupList: [],
      saleableSkuList: [{
        resellerId: null,
        priceType: 0,
        sysResellerId: 0,
        productId: null,
        productSkuId: null,
        supplyPrice: null,
        retailPrice: null,
        merchantsPrice: null,
        marketPrice: null,
        defaultStock: null,
        isShelves: true,
        saleableAreas: []
      }],
      skuInfoNum: 0,
      resellerList: [],
      zoneVisible: false,
      zoneData: [],
      baseAreaList: [], // 后台返回的未格式化的基础区域数据
      alreadySetArae: [],
      saleableSkuIndex: -1,
      dialogVisibleResult: false,
      message: '',
      formTemplate: {
        name: null,
        isActive: true,
        restrictionAreas: []
      },
      configData: null,
      isExpansion: true,
      isCheckModel: false,
      minPrice: null
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(to, from, '路由')
  //   if (from.path == "/Product/AttributeTemplate/Maintain") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
  created() {
    this.getQiniuToken();
    this.getProductNavTypeTree();
    this.getBrandList();
    this.getSupplierList();
    this.getAreaGroupList()
    this.getAllReseller()
  },
  mounted() {
    // this.$nextTick(() => {
    //   console.log(this.productNavTypeTreeList)
    //   if (this.$route.query.copyid&&this.productNavTypeTreeList.length>0) {
    //     this.getAxSpuDetail()
    //   }
    // })
  },
  methods: {
    setConfig() {
      if (!this.configData) {
        return this.$message.error('请输入配置信息')
      }
      this.setData()
    },
    clearConfig() {
      this.configData = null;
      this.setData();
    },
    setData() {
      let tempData = this.zoneData;
      tempData.forEach(item => {
        item.stock = this.configData ? this.configData : null;
        if (item.children) {
          item.children.forEach(item => {
            item.stock = this.configData ? this.configData : null;
          })
        }
      })
      this.zoneData = tempData;
    },
    toggleRowExpansion() {
      this.isExpansion = !this.isExpansion
      this.toggleRowExpansion_forAll(this.zoneData, this.isExpansion);
    },
    toggleRowExpansion_forAll(data, isExpansion) {
      data.forEach(item => {
        this.$refs.topicTable.toggleRowExpansion(item, isExpansion);
        if (item.children != undefined && item.children != null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      })
    },
    backSku() {
      this.$router.push('/Product/SkuList/Index')
    },
    getAreaGroupList() {
      let data = {
        isActive: true,
        skipCount: 0,
        maxResultCount: 100
      }
      RestrictionAreaGroupGetAll(data).then(res => {
        if (res.data.success) {
          this.areaGroupList = res.data.result.items
        }
      })
    },
    backBtn(i) {
      this.stepIndex = i
    },
    // sku信息提交处理
    handleSkuinfo1(arr) {
      let list = arr.filter(item => {
        return item.isShow
      })
      let flage = list.every(item => {
        return item.propertyValueExtString && item.pictureUrl
      })
      console.log(flage, 'flage')
      if (!flage) {
        return this.$message.error('以上数据都为必填,还有数据未填,请填写!')
      }
      let items = []
      list.forEach(item => {
        let propertyList1 = [], propertyList2 = []
        propertyList1 = [{
          propertyId: item.propertyId,
          propertyString: item.propertyString,
          propertyValueId: item.propertyValueId,
          propertyValueString: item.propertyValueString
        }]
        propertyList2 = [{
          propertyId: item.propertyId,
          propertyString: item.propertyString,
          propertyValueId: item.propertyValueId,
          propertyValueString: item.propertyValueExtString
        }]
        items.push({
          propertyCode: item.propertyCode,
          productCode: item.productCode,
          "pictureUrl": item.pictureUrl,
          restrictionAreaGroupId: item.restrictionAreaGroupId,
          restrictionAreaItems: item.restrictionAreaItems,
          properties: {
            propertyList: propertyList1
          },
          propertiesExt: {
            propertyList: propertyList2
          }
        })
      })
      return items
    },
    allSkuListFilter(list) {
      return list.filter(item => {
        item.children = this.allSkuListFilter(item.children)
        return item.isShow
      })
    },
    allSkuListFlage(list) {
      let flage = false
      flage = list.every(item => {
        item.flage = item.children.every(val => {
          return val.propertyValueExtString && val.pictureUrl
        })
        return item.propertyValueExtString && item.flage
      })
      return flage
    },
    handleSkuinfo2(arr) {
      let list = this.allSkuListFilter(arr)
      let flage = this.allSkuListFlage(list)
      if (!flage) {
        return this.$message.error('以上数据都为必填,还有数据未填,请填写!')
      }
      console.log(list, this.allSkuList, 'this.allSkuList')
      let items = []
      list.forEach(item => {
        item.children.forEach(val => {
          let propertyList1 = [], propertyList2 = []
          // if (val.isShow) {
          propertyList1 = [{
            propertyId: item.propertyId,
            propertyString: item.propertyString,
            propertyValueId: item.propertyValueId,
            propertyValueString: item.propertyValueString
          }, {
            propertyId: val.propertyId,
            propertyString: val.propertyString,
            propertyValueId: val.propertyValueId,
            propertyValueString: val.propertyValueString
          }]
          propertyList2 = [{
            propertyId: item.propertyId,
            propertyString: item.propertyString,
            propertyValueId: item.propertyValueId,
            propertyValueString: item.propertyValueExtString
          }, {
            propertyId: val.propertyId,
            propertyString: val.propertyString,
            propertyValueId: val.propertyValueId,
            propertyValueString: val.propertyValueExtString
          }]
          items.push({
            propertyCode: val.propertyCode,
            productCode: val.productCode,
            "pictureUrl": val.pictureUrl,
            restrictionAreaGroupId: val.restrictionAreaGroupId,
            restrictionAreaItems: val.restrictionAreaItems,
            properties: {
              propertyList: propertyList1
            },
            propertiesExt: {
              propertyList: propertyList2
            }
          })
          // }
        })
      })
      console.log(items, 'propertyJsonExt')
      return items
    },
    nextStep(i) {
      if (this.stepNum > 1) {
        this.stepIndex = 2
        return false
      }
      let data = {
        productId: this.spuId,
        propertyGroupId: this.radioSpec,
        items: this.radioSpec == 125 ? this.handleSkuinfo1(this.editSkuList1) : this.handleSkuinfo2(this.allSkuList)
      }
      ProductSkuCreateMany(data).then(res => {
        if (res.data.success) {
          this.stepNum = 2
          this.stepIndex = i
          this.getProductSkuGetMany()
        }
      })
    },
    headerClassName(row, rowIndex) {
      if (row.columnIndex > 0) {
        return 'showRow'
      }
      // console.log(row, rowIndex,'row, rowIndex')
    },
    specTemplate() {
      this.editSkuList1 = []
      this.allSkuList = []
      this.getPropertyList()
    },
    addSpec1() {
      let index = this.editSkuList1.findIndex(item => {
        return !item.isShow
      })
      this.propertySku.forEach(item => {
        item.restrictionAreaGroupId = 0
        item.restrictionAreaItems = []
      })
      if (this.editSkuList1.length == this.propertySku.length) {
        // 两数组长度相等，此时模板内容全部选中，只做页面操作
        if (index > -1) {
          this.editSkuList1[index].isShow = true
        }
      } else if (this.editSkuList1.length < this.propertySku.length) {
        // children中有未选中的，使其选中；全选之后，从groupChildren做对比添加
        if (index == -1) {
          let obj = this.propertySku[this.editSkuList1.length]
          obj.pictureUrl = this.skuMainpic
          this.editSkuList1.push({ ...obj })
        } else {
          this.editSkuList1[index].isShow = true
        }
      }
    },
    deleteSpec1(row) {
      row.isShow = false
    },
    addProperty() {
      let index = this.allSkuList.findIndex(item => {
        return !item.isShow
      })
      if (this.allSkuList.length == this.propertySku.length) {
        if (index > -1) {
          this.allSkuList[index].isShow = true
        }
      } else if (this.allSkuList.length < this.propertySku.length) {
        if (index == -1) {
          let obj = { ...this.propertySku[this.allSkuList.length] }
          obj.children = [...this.allSkuList[this.allSkuList.length - 1].children]
          this.allSkuList.push({ ...obj })
        } else {
          this.allSkuList[index].isShow = true
        }
      }
      // let obj = {...this.propertySku[this.allSkuList.length]}
      // obj.children = [...this.allSkuList[this.allSkuList.length-1].children]
      // this.allSkuList.push(obj)
      // console.log(this.allSkuList,'this.allSkuList')
    },
    deleteProperty(row) {
      row.isShow = false
    },
    addSpec2(row) {
      console.log(row, 'row')
      let { children } = row
      let groupChildren = this.propertySku[0].children
      groupChildren.forEach(item => {
        item.restrictionAreaGroupId = 0
        item.restrictionAreaItems = []
      })
      console.log(groupChildren, 'groupChildren')
      let index = children.findIndex(item => {
        return !item.isShow
      })
      if (children.length == groupChildren.length) {
        // 两数组长度相等，此时模板内容全部选中，只做页面操作
        if (index > -1) {
          children[index].isShow = true
        }
      } else if (children.length < groupChildren.length) {
        // children中有未选中的，使其选中；全选之后，从groupChildren做对比添加
        if (index == -1) {
          let obj = groupChildren[children.length]
          obj.pictureUrl = this.skuMainpic
          children.push({ ...obj })
        } else {
          children[index].isShow = true
        }
      }
    },
    deleteSpec2(row) {
      row.isShow = false
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return [1, 5];
      } else if (columnIndex === 2) {
        return [0, 0];
      } else if (columnIndex === 3) {
        return [0, 0];
      } else if (columnIndex === 4) {
        return [0, 0];
      } else if (columnIndex === 5) {
        return [0, 0];
      }
    },
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 8) {
        if (rowIndex % this.skuInfoNum === 0) {
          return {
            rowspan: this.skuInfoNum,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    rowClassName(value) {
      let { row, rowIndex } = value
      // console.log(row, rowIndex,'row, rowIndex')
      if (!row.isShow) {
        return 'showRow'
      }
      // this.allSkuList[index].children
    },
    allSelArea() {
      this.$refs.tree.setCheckedNodes(this.areaTreeList);
    },
    clearSelArea() {
      this.$refs.tree.setCheckedNodes([]);
    },
    defaultChecked(keys) { // 默认选中
      this.$nextTick(() => {
        const arr = []
        keys.forEach(key => {
          if (!this.$refs.tree.getNode(key).childNodes || !this.$refs.tree.getNode(key).childNodes.length) {
            arr.push(key)
          }
        })
        this.$refs.tree.setCheckedKeys(arr)
      })
    },
    renderAreaTree(index, i) {
      this.skuIndex = index
      this.skuChildIndex = i
      this.areaSetFormVisible = true
      this.formTemplate = {
        name: null,
        isActive: true,
        restrictionAreas: []
      }
      let params = {
        MaxLevel: 2
      };
      GetAreaTree(params).then((res) => {
        this.areaTreeList = this.loopTree(res.data.result.children);
        return false
        if (this.radioSpec == 125) {
          let checkdKeys = [];
          this.editSkuList1[index].restrictionAreaItems.forEach(x => {
            checkdKeys.push(x.areaId);
          })
          this.defaultChecked(checkdKeys)
        }
        if (this.radioSpec == 124) {
          let checkdKeys = [];
          this.allSkuList[index].children[i].restrictionAreaItems.forEach(x => {
            checkdKeys.push(x.areaId);
          })
          this.defaultChecked(checkdKeys)
        }
      });
    },
    loopTree(treeList, lastFullId) {
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopTree(item.children, item.areaFullId)
        }
        return true;
      })
      return newList;
    },
    submitAreaSet() {
      let checkedNodes = this.$refs.tree.getCheckedNodes(false, true);
      var newObject = JSON.parse(JSON.stringify(checkedNodes));
      newObject.forEach(x => {
        if (x.children) {
          delete x.children
        }
      })
      this.formTemplate.restrictionAreas = newObject
      RestrictionAreaGroupCreate(this.formTemplate).then((res) => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.areaSetFormVisible = false;
          this.getAreaGroupList()
        } else {
          this.$message.error(res.data.msg);
        }
      })
      return false
      console.log(newObject, 'newObject')
      console.log(this.skuIndex, this.skuChildIndex, 'this.skuChildIndex')
      if (this.radioSpec == 125) {
        this.editSkuList1[this.skuIndex].restrictionAreaItems = newObject
      } else {
        this.allSkuList[this.skuIndex].children[this.skuChildIndex].restrictionAreaItems = newObject
      }
      this.areaSetFormVisible = false;
    },
    // 获取sku价格信息
    getProductSkuGetMany() {
      let data = {
        productId: this.spuId
      }
      ProductSkuGetMany(data).then(res => {
        if (res.data.success) {
          this.skuInfoNum = res.data.result.length
          // res.data.result.forEach(itme => {
          //   if (itme.restrictionAreas.length>0) {
          //     itme.restrictionAreas.forEach(val => {
          //       val.stock = 0
          //     })
          //   }
          // })
          this.editSkuList2 = res.data.result
          let list = res.data.result
          let arr = []
          list.forEach(item => {
            arr.push({
              propertyDisplayExt: item.propertyDisplayExt,
              checked: true,
              resellerId: this.resellerList[0].id,
              priceType: this.resellerList[0].priceType,
              sysResellerId: this.resellerList[0].sysResellerId,
              productId: item.productId,
              productSkuId: item.id,
              supplyPrice: null,
              retailPrice: null,
              merchantsPrice: null,
              marketPrice: null,
              defaultStock: null,
              isShelves: true,
              saleableAreas: []
              // saleableAreas: item.restrictionAreas
            })
          })
          this.saleableSkuList = arr
          this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
        }
      })
    },
    addReseller() {
      this.editSkuList2.forEach(item => {
        this.saleableSkuList.push({
          checked: true,
          propertyDisplayExt: item.propertyDisplayExt,
          resellerId: null,
          priceType: 0,
          sysResellerId: 0,
          productId: item.productId,
          productSkuId: item.id,
          supplyPrice: null,
          retailPrice: null,
          merchantsPrice: null,
          marketPrice: null,
          defaultStock: null,
          isShelves: true,
          // saleableAreas: item.restrictionAreas
          saleableAreas: []
        })
      })
      this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
    },
    deleteReseller(index) {
      this.saleableSkuList.splice(index, this.skuInfoNum)
      this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
    },
    getAllReseller() {
      let data = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      GetAllReseller(data).then(res => {
        if (res.data.success) {
          this.resellerList = res.data.result.items
        }
      })
    },
    clearSelect(index) {
      let num = index + this.skuInfoNum
      for (let i = index; i < num; i++) {
        this.saleableSkuList[i].resellerId = null
        this.saleableSkuList[i].priceType = 0
        this.saleableSkuList[i].sysResellerId = 0
      }
      this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
    },
    changeReseller(val, index) {
      if (!val) { return false }
      let num = index + this.skuInfoNum
      let resellerInfo = this.resellerList.filter(v => {
        return v.id == val
      })[0]
      let flage = this.objArr.filter(item => {
        return item.sysResellerId == resellerInfo.sysResellerId
      })
      let target = this.objArr[index]
      if (target.sysResellerId == resellerInfo.sysResellerId && target.resellerId != resellerInfo.resellerId) {
        for (let i = index; i < num; i++) {
          this.saleableSkuList[i].resellerId = val
          this.saleableSkuList[i].priceType = resellerInfo.priceType
        }
      } else if (flage.length) {
        for (let i = index; i < num; i++) {
          this.saleableSkuList[i].resellerId = this.objArr[index].resellerId
          this.saleableSkuList[i].priceType = this.objArr[index].priceType
          this.saleableSkuList[i].sysResellerId = this.objArr[index].sysResellerId
        }
        return this.$message.error('无法同时选择相同的系统分销商')
      } else {
        for (let i = index; i < num; i++) {
          this.saleableSkuList[i].resellerId = val
          this.saleableSkuList[i].priceType = resellerInfo.priceType
          this.saleableSkuList[i].sysResellerId = resellerInfo.sysResellerId
        }
        this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
      }
      // console.log(this.saleableSkuList,'this.saleableSkuList2')
    },
    saveReseller(isSyncPush) {
      if (this.stepNum > 2) {
        return false
      }
      let list = this.saleableSkuList.filter(item => {
        return item.checked
      })
      let flage = list.every(item => {
        if (item.priceType == 1) {
          return item.resellerId && item.supplyPrice && item.defaultStock >= '0'
        } else {
          return item.resellerId && item.supplyPrice && item.retailPrice && item.marketPrice && item.defaultStock >= '0'
        }
      })
      if (!flage) {
        return this.$message.error('所选数据都为必填,还有数据未填！')
      }
      list.forEach(val => {
        val.isShelves = isSyncPush
        val.supplyPrice = Number(val.supplyPrice)
        val.merchantsPrice = Number(val.supplyPrice)
        if (val.priceType == 1) {
          val.retailPrice = Number(val.supplyPrice)
          // val.merchantsPrice = Number(val.supplyPrice)
          val.marketPrice = Number(val.supplyPrice)
        } else {
          val.retailPrice = val.retailPrice ? Number(val.retailPrice) : val.retailPrice
          // val.merchantsPrice = val.merchantsPrice ? Number(val.merchantsPrice) : val.merchantsPrice
          val.marketPrice = val.marketPrice ? Number(val.marketPrice) : val.marketPrice
        }
      })
      let data = {
        isSyncPush: isSyncPush,
        items: list
      }
      CreateOrUpdateMany(data).then(res => {
        if (res.data.success) {
          this.stepNum = 3
          if (res.data.result) {
            this.dialogVisibleResult = true
            this.message = res.data.result
            // this.$message.success(res.data.result)
          } else {
            this.$message.success('保存成功')
            location.reload()
          }
        } else {
          this.$message.error(res.data.error.message)
        }
      }).catch(e => {
        console.log(e)
      }) 
    },
    handleUpdateSaleArea() {
      this.updateRes = []
      this.filterData(this.zoneData)
      this.saleableSkuList[this.saleableSkuIndex].saleableAreas = this.updateRes
      this.zoneVisible = false
      console.log(this.updateRes, 'this.updateRes')
    },
    filterData(list) {
      list.forEach(i => {
        if (i.stock >= 0 && i.stock !== null && i.stock !== '' && i.stock !== undefined) {
          this.updateRes.push({
            "areaId": i.areaId,
            "areaName": i.areaName,
            "areaFullId": i.areaFullId,
            "stock": i.stock
          })
        }
        if (i.children && i.children.length) {
          this.filterData(i.children)
        }
      })
    },
    async setZone(row, index) {
      // console.log('row', row);
      this.saleableSkuIndex = index
      this.saleableSkuId = row.saleableSkuId
      this.alreadySetArae = []
      // 基础区域数据没有则重新获取
      if (!this.baseAreaList.length) {
        let res = await GetAreaTree({ MaxLevel: 2 })
        // console.log('2级', res);
        this.baseAreaList = res.data.result.children
        console.log(this.baseAreaList, 'this.baseAreaList')
      }
      // 获取已设置区域库存的区域数据
      let setRes = await GetSaleableAreas({ saleableSkuId: row.saleableSkuId });
      this.alreadySetArae = setRes.data.result
      // console.log('alreadySetArae', this.alreadySetArae)
      // 组装数据
      let list = JSON.parse(JSON.stringify(this.baseAreaList))
      this.zoneData = this.loopAreaTree(list)
      this.zoneVisible = true;
    },
    loopAreaTree(treeList, lastFullId) {
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        // 设置库存
        let t = this.saleableSkuList[this.saleableSkuIndex].saleableAreas.find(i => i.areaId === item.data.Id)
        item.stock = t ? t.stock : null
        // item.disabled = item.stock == 0? true: false
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopAreaTree(item.children, item.areaFullId)
        }
        // filter return true
        return true;
      })
      return newList;
    },
    getIdByLevelTwo(currentItem) {
      let ids = [];
      let secondId;
      let thirdId;
      secondId = currentItem.id;
      ids.push(secondId)

      let firstItem = this.afterFlatTypeTree.filter((item) => {
        return item.id = currentItem.pid
      })
      ids.unshift(firstItem.id)
      let thirdPid = secondId;
      let thirdItem = this.afterFlatTypeTree.filter((item) => {
        return item.pid = thirdPid
      })
      thirdId = thirdItem.id;
      ids.push(thirdId)
      return ids
    },
    getIdByLevelOne(currentItem) {
      let ids = [];
      let firstId;
      let secondId;
      let thirdId;
      firstId = currentItem.id;
      ids.push(firstId)
      let secondPid = firstId;
      let secondItem = this.afterFlatTypeTree.filter((item) => {
        return item.pid = secondPid
      })
      secondId = secondItem.id;
      ids.push(secondId)
      let thirdPid = secondId;
      let thirdItem = this.afterFlatTypeTree.filter((item) => {
        return item.pid = thirdPid
      })
      thirdId = thirdItem.id;
      ids.push(thirdId)
      return ids
    },
    getIdByLevelThree(currentItem) {
      let ids = [];
      let secondId;
      let thirdId;
      thirdId = currentItem.id;
      let secondItem = this.afterFlatTypeTree.filter((item) => {
        return item.id = currentItem.pid
      })
      ids.unshift(secondItem.id)
      let thirdItem = this.afterFlatTypeTree.filter((item) => {
        return item.id = secondItem.pid
      })
      ids.unshift(thirdItem.id)
      ids.push(thirdId)
    },
    button2() {
      return (
        <div>
          <span style="margin-right:5px;">属性图</span>
          <el-button on-click={() => this.copyPictureUrl()} type="primary" size="small">向下覆盖</el-button>
        </div>
      )
    },
    button1() {
      return (
        <div>
          <span style="margin-right:5px;">成本价</span>
          <el-button on-click={() => this.copyCostPrice()} type="primary" size="small">向下覆盖</el-button>
        </div>
      )
    },
    button() {
      return (
        <div>
          <span style="margin-right:5px;">商品编码</span>
          <el-button on-click={() => this.copyProductCode()} type="primary" size="small">向下覆盖</el-button>
        </div>
      )
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    getIds(typeName) {
      // console.log('productNavTypeTreeListproductNavTypeTreeList', this.productNavTypeTreeList)
      // console.log('afterFlatTypeTreeafterFlatTypeTreeafterFlatTypeTreeafterFlatTypeTree', this.afterFlatTypeTree)
      let ids = [];
      let firstId = null;
      let typeArr = typeName.split(',')
      // typeName 名称顺序与级别顺序一致
      let firstName = typeArr[0];
      // console.log('firstName: ' + firstName)

      let FlatTypeTree = [...this.afterFlatTypeTree]
      let currentItem = [];
      FlatTypeTree.forEach((item) => {
        if (item.name === firstName) {
          currentItem.push(item)
        }
      })
      // console.log('FlatTypeTree', FlatTypeTree)
      // console.log('currentItem', currentItem, currentItem.level)
      // let currentItem = this.afterFlatTypeTree.filter((item) => {
      //   return item.name = firstName
      // })

      if (currentItem.level == 1) {
        return firstId = this.getIdByLevelOne(currentItem)
      }

      if (currentItem.level == 2) {
        // console.log('222222222222222')
        return firstId = this.getIdByLevelTwo(currentItem)
      }

      if (currentItem.level == 3) {
        return firstId = this.getIdByLevelThree(currentItem)
      }

    },
    flatTypeTree(arr) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        newArr.push({ id: arr[i].value, name: arr[i].label, pid: arr[i].ParentId, level: arr[i].level });
        if (arr[i].children && arr[i].children.length > 0) {
          newArr = newArr.concat(this.flatTypeTree(arr[i].children))
        }
      }
      return newArr;
    },
    findParents(treeData, value, key) {
      if (treeData.length == 0) return
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i][key] == value) {
          return [treeData[i].value]
        } else {
          if (treeData[i].children) {
            let res = this.findParents(treeData[i].children, value, key)
            if (res) {
              return res
            }
          }
        }
      }
    },
    findParentsByName(treeData, value, key) {
      let list = []
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i][key] == value) {
          list.push(treeData[i].value)
        } else {
          if (treeData[i].children) {
            for (let j = 0; j < treeData[i].children.length; j++) {
              let obj1 = treeData[i].children[j]
              if (obj1[key] == value) {
                list.push(obj1.value)
              } else {
                if (obj1.children) {
                  for (let z = 0; z < obj1.children.length; z++) {
                    let obj2 = obj1.children[z]
                    if (obj2[key] == value) {
                      list.push(obj2.value)
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (list.length > 0) {
        return list[0]
      } else {
        return null
      }
    },
    findAllParents(treeData, value) {
      if (!value) { return false }
      for (let item of treeData) {
        if (item.value === value) {
          //将查找到的目标数据加入结果数组中
          //可根据需求unshift(item.id)或unshift(item)
          this.goodDetailForm.categories.unshift({
            categoryId: item.value,
            categoryName: item.label
          })
          return true
        }
        if (item.children && item.children.length > 0) {
          //根据查找到的结果往上找父级节点
          let isFind = this.findAllParents(item.children, value)
          if (isFind) {
            this.goodDetailForm.categories.unshift({
              categoryId: item.value,
              categoryName: item.label
            })
            return true
          }
        }
      }
      //走到这说明没找到目标
      return false
    },
    async setCurrentIndex(item, index) {
      console.log('item index', item, index)
      // CheckProhibited({ modelCode: item.modelCode }).then(res => {
      //   if (res.data.result) {
      //     this.isCheckModel = true
      //   } else {
      //     this.isCheckModel = false
      //     this.currentIndex = index;
      //     this.checkedModelId = item.id; // 查询商品的型号Id
      //     if (this.checkedModelId) {
            let params = {}
            params.Id = item.id
            Product_SpuModelGetDetail(params).then(res => {
              console.log('型号查询结果', res);
              if (res.data.success) {
                this.goodDetailForm.pictures = []
                let object = res.data.result.data;
                if (object.brandName) {
                  // 根据商城 品牌名称 查询 erp 对应的 品牌名称  品牌Id
                  let brandItem = this.brandList.filter(Item => Item.value === object.brandName)
                  console.log('brandItem', brandItem)
                  if (brandItem && brandItem.length > 0) {
                    this.goodDetailForm.brandName = brandItem[0].value;
                    this.goodDetailForm.brandId = brandItem[0].id;
                  }
                }
                // let categoryName = object.typeNames;
                // if (!categoryName) {
                //   return this.$message.error('缺少级别名称')
                // }
                // // // 根据类型名称获取  三级类型id
                // let categoryIds = this.getIds(categoryName);
                // console.log('categoryIdscategoryIdscategoryIds', categoryIds)
                // let currentTypeId = this.getCurrentTypeId(categoryName)

                // this.goodDetailForm.categoryId = [];
                let arr = []
                if (object.typeId) {
                  arr = this.findParents(this.productNavTypeTreeList, object.typeId, 'value')
                  if (arr && arr.length > 0) {
                    this.goodDetailForm.categoryId = arr[0]
                    this.findAllParents(this.productNavTypeTreeList, this.goodDetailForm.categoryId)
                  }
                }
                if (object.typeName && !arr) {
                  arr = this.findParents(this.productNavTypeTreeList, object.typeName, 'label')
                  if (arr && arr.length > 0) {
                    this.goodDetailForm.categoryId = arr[0]
                    this.findAllParents(this.productNavTypeTreeList, this.goodDetailForm.categoryId)
                  }
                }
                if (object.modelCode) {
                  this.goodDetailForm.model = object.modelCode;
                }
                if (object.proContent) {
                  this.goodDetailForm.introduce = object.proContent
                }
                if (object.businessPics && object.businessPics.length > 0) {
                  object.businessPics.forEach((item, index) => {
                    this.goodDetailForm.pictures.push({
                      url: item,
                      type: index == 0 ? 0 : 1
                    })
                  })
                }
                this.isModelListShow = false;
                this.modelListLoading = false;
                this.modelList = [];
              } else {
                this.isModelListShow = false;
                this.modelListLoading = false;
                this.modelList = [];
                this.$message.error(res.data.error.message)
              }
            })
      //     }
      //   }
      // })
    },
    getModelCode: _.debounce(async function (val) {
      try {
        if (val) {
          GetProhibitedList({ modelCode: val }).then(res => {
            if (res.data.result && res.data.result.length) {
              this.isCheckModel = true
              this.minPrice = res.data.result[0].minPrice
            } else {
              this.isCheckModel = false
              this.minPrice = null
              this.currentIndex = null // 选中索引
              this.modelList = []  // 重置型号搜索结果
              this.isModelListShow = true  // 显示搜索结果框
              this.modelListLoading = true  // 搜索结果框loading
              let params = {}
              params.modelCode = val
              GetSimpleList(params).then(res => {
                if (res.data.success) {
                  if (res.data.result && res.data.result.length > 0) {
                    this.modelList = res.data.result
                    this.modelListLoading = false
                    this.isSearch = false // 隐藏搜索
                  } else {
                    this.isModelListShow = false
                    this.modelListLoading = false
                    this.isSearch = true
                  }
                } else {
                  this.$message.error(res.data.error.message)
                  this.modelList = []
                  this.isModelListShow = false
                  this.modelListLoading = false
                }
              })
            }
          })
          return
        } else {
          this.modelList = []
          this.isModelListShow = false
          this.modelListLoading = false
          this.currentIndex = null
          // 清空之前已经查询的商品详情数据
          this.goodDetailForm.pictures = [];
          this.goodDetailForm.brandName = '';
          this.goodDetailForm.brandId = null;
          this.goodDetailForm.model = null;
          this.goodDetailForm.categoryId = null;
          this.isSearch = false; // 隐藏  搜索 为空 提示
        }

      } catch (e) {
        this.modelList = []
        this.isModelListShow = false
        this.modelListLoading = false
        this.currentIndex = null
        console.log(e)
      }
    }, 2000),
    // 获取sku模板
    getPropertyList() {
      let data = {
        type: this.radioSpec
      }
      PropertyGroupTree(data).then(res => {
        if (res.data.success) {
          this.propertySku = res.data.result
          let obj = { ...this.propertySku[0] }
          let data = {
            "propertyValueExtString": "",
            "pictureUrl": this.skuMainpic,
            "productCode": null,
            "restrictionAreaGroupId": 0,
            "restrictionAreaItems": [],
          }
          if (this.radioSpec == 125) {
            let data1 = {}
            data1 = Object.assign(data, obj)
            this.editSkuList1.push(data1)
          }
          if (this.radioSpec == 124) {
            let data2 = { ...this.propertySku[0].children[0] }
            data = Object.assign(data, data2)
            console.log(data, 'Object.assign')
            obj.children = [data]
            console.log(obj.children, 'obj.children')
            this.allSkuList.push(obj)
          }
        }
      })
    },
    // 营客通商品库详情
    getAxSpuDetail() {
      let data = {
        spuId: this.$route.query.copyid,
        pageIndex: 1,
        pageSize: 10
      }
      GetKSAXCommodityLibrary(data).then(res => {
        if (res.data.success) {
          let object = res.data.result.data.data[0] || {}
          object.businessPics.forEach(item => {
            this.goodDetailForm.pictures.push({
              url: item.spuPicUrl,
              type: item.isMain ? 0 : 1
            })
          })
          this.goodDetailForm.name = object.proName
          this.goodDetailForm.introduce = object.proContent
          this.goodDetailForm.model = object.modelCode
          if (object.brandName) {
            // 根据商城 品牌名称 查询 erp 对应的 品牌名称  品牌Id
            let brandItem = this.brandList.filter(Item => Item.value === object.brandName)
            if (brandItem && brandItem.length > 0) {
              this.goodDetailForm.brandName = brandItem[0].value;
              this.goodDetailForm.brandId = brandItem[0].id;
            }
          }
          if (this.productNavTypeTreeList.length > 0) {
            let typeIds = object.typeIds.split(',')
            let typeId = typeIds[typeIds.length - 1] || null
            let typeNames = object.typeName.split('/')
            let typeName = typeNames[typeNames.length - 1] || null
            let treeData = this.productNavTypeTreeList
            let categoryId1 = null, categoryId2 = null
            if (typeId) {
              categoryId1 = this.findParentsByName(treeData, typeId, 'value')
              this.goodDetailForm.categoryId = categoryId1 ? categoryId1 : null
              this.findAllParents(treeData, categoryId1)
            }
            if (typeName && !categoryId1) {
              categoryId2 = this.findParentsByName(treeData, typeName, 'label')
              this.goodDetailForm.categoryId = categoryId2 ? categoryId2 : null
              this.findAllParents(treeData, categoryId2)
            }
          }
        }
      })
    },
    select_blur_supplier() {
      // this.sourceType = 1;
      this.getSupplierList();
    },
    clearSupplier() {
      // console.log('clear')
      this.goodDetailForm.sourceType = 0
      this.goodDetailForm.sourceId = 0
    },
    changeType(val) {

      if (val === 1) {
        this.typeShow = true;
        this.goodDetailForm.sourceType = 0
        this.goodDetailForm.sourceId = 0
      } else {
        this.typeShow = false;
        this.goodDetailForm.sourceType = 1
        this.goodDetailForm.sourceId = null
      }
    },
    getSupplierList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      let that = this;
      GetAllSupplier(params).then((res) => {
        if (res.data.success) {
          that.supplierList = res.data.result.items;
          that.supplierList.unshift({ proSupplierName: '自有商品', id: 0 })
        }
      });
    },
    watchCostPrice(val, data) {
      if (val <= 0) {
        data.costPrice = null
      }
    },
    getBrandList(key) {
      let obj = {
        IsActive: true,
        SkipCount: 0,
        MaxResultCount: 100000,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.goodDetailForm.brandId = item.id;
    },
    listToTree(arr) {
      let list = []
      // arr.forEach(item => {
      //   list.push({
      //     id: item.propertyId,
      //     checkedCities: item.propertyValues.map(val => {
      //       return val.propertyValueId
      //     })
      //   })
      // })
      arr.forEach(item => {
        let id = item.propertyId
        let index = list.findIndex(val => val.id == item.propertyId)
        if (index > -1) {
          list[index].checkedCities.push(item.propertyValueId)
        } else {
          list.push({
            id: item.propertyId,
            checkedCities: [item.propertyValueId]
          })
        }
        // if (obj.hasOwnProperty(item.checkedCities)) {
        //   list[obj[item.id]][item.checkedCities] = item.propertyId
        //   list[obj[item.propertyId]][item.checkedCities] = item.propertyValueId
        // } else {
        //   obj[item.propertyId] = index++
        //   list.push({
        //     id: item.propertyId,
        //     checkedCities: [item.propertyValueId]
        //   })
        // }
      })
      // console.log(arr, list)
      return list
    },
    catchDetailData(data) {
      this.goodDetailForm.introduce = data;
    },
    // 商品类型
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0, isActive: true }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
        let FlatTypeTree = this.flatTypeTree(that.productNavTypeTreeList);
        this.afterFlatTypeTree = FlatTypeTree
        // console.log('this.afterFlatTypeTree=====', this.afterFlatTypeTree)
        // console.log(that.productNavTypeTreeList, 'kkkkk')
        if (that.$route.query.copyid && that.productNavTypeTreeList.length > 0) {
          that.getAxSpuDetail()
        }
      });
    },
    loopTypeTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        item.ParentId = item.data.ParentId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    loopMenuTree(treeList, level = 0) {
      level++
      const newList = treeList.filter(item => {
        item.level = level;
        item.value = item.data.Id;
        item.label = item.data.Name;
        item.ParentId = item.data.ParentId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children, level)
        }
        return true;
      })
      return newList;
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleDelPic(index) {
      let that = this;
      that.goodDetailForm.pictures.splice(index, 1);
    },
    handleBusinessPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic;
          if (that.goodDetailForm.pictures[0]) {
            itemPic = {
              url: res,
              type: 1,
            };
          } else {
            itemPic = {
              url: res,
              type: 0,
            };
          }
          that.goodDetailForm.pictures.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    // 属性组合
    selectScep() {
      GetProductSkuPreView({ ProductId: this.spuId }).then(res => {
        if (res.data.success) {
          this.dialogCombination = true
          this.skuPreViewList = res.data.result || []
          this.$nextTick(() => {
            this.createSkuList.forEach(row => {
              let index = this.skuPreViewList.findIndex(i => {
                return i.speCode === row.speCode
              })
              if (index > -1) {
                // this.$set(this.skuPreViewList[i].items[findTargIndex], 'isCheck', true)
                this.$refs.diaTable.toggleRowSelection(this.skuPreViewList[index])
              }
            })
          })
        }
      })
    },
    deepCopy(obj) {
      let newObj = null;
      if (typeof (obj) == 'object' && typeof (obj) !== null) {
        newObj = obj instanceof Array ? [] : {};
        for (var i in obj) {
          newObj[i] = this.deepCopy(obj[i]);
        }
      } else {
        newObj = obj;
      }
      return newObj;
    },
    // 添加/编辑商品
    addOrUpdata() {
      // let that = this;
      if (this.spuId) {
        this.stepIndex = 1
        return false
      }
      if (this.goodDetailForm.sourceId) {
        // params.sourceId = 0;
        this.goodDetailForm.sourceType = 1;
      } else {
        this.goodDetailForm.sourceType = 0;
      }
      if (!this.goodDetailForm.categoryId)
        return this.$message.error("请选择商品类型！");
      if (!this.goodDetailForm.name)
        return this.$message.error("请输入商品名称！");
      if (!this.goodDetailForm.model)
        return this.$message.error("请输入商品型号！");
      if (!this.goodDetailForm.brandId)
        return this.$message.error("请选择商品品牌！");
      if (this.goodDetailForm.sourceType === null)
        return this.$message.error("请选择商品归属！");
      // if (this.goodDetailForm.sourceType === 1 && this.goodDetailForm.sourceId === null)
      //   return this.$message.error("请选择供应商");
      if (!this.goodDetailForm.pictures[0])
        return this.$message.error("请上传商品展示图片！");
      if (!this.goodDetailForm.introduce)
        return this.$message.error("请填写商品描述！");
      let pattern = /https?:\/\/?/
      if (pattern.test(this.goodDetailForm.serviceContent)) {
        return this.$message.error('补充说明请勿输入跳转链接')
      }
      let params = JSON.parse(JSON.stringify(this.goodDetailForm));
      // return false
      // CheckProhibited({ modelCode: this.goodDetailForm.model }).then(res => {
      //   if (res.data.result) {
      //     this.isCheckModel = true
      //     return that.$message.error('很抱歉，因厂家限制要求，该型号无法进行添加上架，如有疑问请联系相关负责人！')
      //   } else {
          this.isCheckModel = false
          this.$confirm("确认提交吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning",
          })
            .then(() => {
              // if (!this.$route.query.id) {
              ProductCreate(params).then((res) => {
                if (res.data.success) {
                  this.stepNum = 1
                  this.stepIndex++
                  this.$message.success('添加成功！');
                  // this.disabledSpu = true
                  this.spuId = res.data.result.id
                  this.createSkuList = []
                  this.getPropertyList()
                  // this.$router.go(0);
                } else {
                  this.$message.error(res.data.error.message);
                }
              });
            });
        // }
      // })
    },
    handleSelectionChange(arr) {
      console.log(arr, '规格')
      this.checkedSkuList = arr
    },
    confrimSku() {
      let list = []
      this.checkedSkuList.forEach(item => {
        list.push({
          "speCode": item.speCode,
          "productSpec": item.productSpec,
          "propertyJson": item.propertyJson,
          "propertyJsonArr": JSON.parse(item.propertyJson),
          "productCode": "",
          "pictureUrl": this.skuMainpic,
          "costPrice": null,
          "isActive": true
        })
      })
      if (!this.createSkuList[0]) {
        this.createSkuList = list
      } else {
        list.forEach(item => {
          item.propertyJsonArr.PropertyList.forEach(val => {
            this.createSkuList.forEach(item2 => {
              item2.propertyJsonArr.PropertyList.forEach(val2 => {
                if (val2.PropertyValueId == val.PropertyValueId) {
                  val.PropertyValueString = val2.PropertyValueString
                }
              })
            })
          })
        })
        this.createSkuList = this.arrayDup(this.createSkuList, list)
      }
      console.log(this.createSkuList, 'this.createSkuList')
      this.dialogCombination = false
    },
    // 处理同一属性名称
    changeInputSpec(spec, value) {
      this.createSkuList.forEach(item => {
        item.propertyJsonArr.PropertyList.forEach(val => {
          if (spec.PropertyValueId == val.PropertyValueId) {
            val.PropertyValueString = value
          }
        })
      })
    },
    // 去重
    arrayDup(arr1, arr2) {
      let list1 = [], list2 = []
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].speCode == arr2[j].speCode) {
            list1.push(arr1[i])
          }
        }
      }
      arr2.forEach(item => {
        let index = arr1.findIndex(i => {
          return i.speCode === item.speCode
        })
        if (index < 0) {
          list2.push(item)
        }
      })
      return list1.concat(list2)
    },
    // 保存sku
    handleSubmitSku() {
      // 校验成本价不能为空
      let elements = document.querySelectorAll('#container .cost-price input');
      for (let el of elements) {
        el.classList.remove("input-err");
      }
      for (let el of elements) {
        if (isNaN(el.valueAsNumber)) {
          el.classList.add("input-err");
          return this.$message.error('成本价不能为空');
        }
      }

      // console.log(this.createSkuList,'保存sku')
      // let list = this.createSkuList
      this.createSkuList.forEach(i => {
        i.productSpecExt = ''
        i.propertyJsonArr.PropertyList.forEach(v => {
          i.productSpecExt += `${v.PropertyString}*`
        })
        i.propertyJsonExt = JSON.stringify(i.propertyJsonArr)
      })
      let data = {
        productId: this.spuId,
        items: this.createSkuList
      }
      BatchCreateAndUpdate(data).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
          // this.disabledSku = true
          // this.disabledSpu = false
        }
      })
    },
    // getSkuList() {
    //   ProductSkuGetAll({ProductId: this.spuId}).then(res => {
    //     this.createSkuList = res.data.result.items || []
    //   })
    // },
    deleteSku(data, index) {
      // if (data.id) {
      //   ProductSkuDelete({ids: [data.id]}).then(res => {
      //     if (res.data.success) {
      //       this.getSkuList()
      //     }
      //   })
      // } else {
      this.createSkuList.splice(index, 1)
      // }
    },
    // 图片放大
    handleBigPic(src) {
      this.dialogVisible = true;
      this.dialogImageUrl = src;
    },
    setMain(index) {
      let that = this;
      that.goodDetailForm.pictures.forEach((v, i) => {
        if (index == i) {
          var arr = [
            {
              url: that.goodDetailForm.pictures.splice(i, 1)[0].url,
              type: 0,
            },
          ];
          that.goodDetailForm.pictures = [
            ...arr,
            ...that.goodDetailForm.pictures,
          ];
        }
      });
      that.goodDetailForm.pictures.forEach((v, i) => {
        if (i > 0) {
          v.type = 1;
        }
      });
    },
    handleSkuChange(e, i) {
      // console.log(e,i,'e,i')
      // return false
      let that = this;
      let file = e.target.files[0];
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file, qiniuData).then((res) => {
        window.document.getElementById("el_upload_input").value = null;
        // i.pictureUrl = res;
        that.$set(i, 'pictureUrl', res)
        // if (i != null) {
        //   that.createSkuList[i].pictureUrl = res;
        // }
      })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    delSkuPic(i) {
      i.pictureUrl = ''
      // this.createSkuList[i].pictureUrl = "";
    },
    copyProductCode() {
      let productCode = ''
      if (this.createSkuList[0].productCode) {
        productCode = this.createSkuList[0].productCode
        this.createSkuList.forEach(item => {
          item.productCode = productCode
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyCostPrice() {
      let costPrice = ''
      if (this.createSkuList[0].costPrice) {
        costPrice = this.createSkuList[0].costPrice
        this.createSkuList.forEach(item => {
          item.costPrice = costPrice
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyPictureUrl() {
      let pictureUrl = ''
      if (this.createSkuList[0].pictureUrl) {
        pictureUrl = this.createSkuList[0].pictureUrl
        this.createSkuList.forEach(item => {
          item.pictureUrl = pictureUrl
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
  },
};
</script>
<style scoped>
.step-box {
  color: #606266;
  margin-bottom: 15px;
  cursor: pointer;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.stepOn {
  color: #000;
  font-weight: 700;
}

.mglr10 {
  margin: 0 10px;
}

.flex-wrap {
  display: flex;
}

.flex-end {
  align-items: end;
}

#allsku /deep/ .showRow {
  display: none;
}

.active {
  color: #2a7ffa;
  background-color: pink;
}

.modelStyle {
  border: 1px solid red;
  width: 300px;
  min-height: 200px;
  max-height: 300px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  overflow-y: scroll;
  padding-top: 10px;
  padding-left: 10px;
  line-height: 35px;
}

.modelCodeStyle ::-webkit-scrollbar {
  width: 4px;
}

.modelCodeStyle ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.modelCodeStyle ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.add_main {
  min-height: 100%;
  padding: 10px 20px 100px 20px;
  overflow: hidden;
}

.blue-txt {
  color: #409eff;
}

.el-input,
.el-cascader,
.el-autocomplete {
  width: 300px;
}

.el-textarea {
  width: 500px;
}

.el-form {
  padding-left: 20px;
}

.tab_box {
  padding: 20px;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.img-uploader {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.img-uploader:hover {
  border-color: #409eff;
}

.img-uploader .el_upload {
  height: 80px;
  width: 80px;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.set_main {
  position: absolute;
  bottom: -40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-share {
  position: absolute;
  bottom: -70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.params_box div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.from_tit {
  color: #606266;
  margin-right: 20px;
}

.params_box ul {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.params_box ul>li {
  padding: 0 10px;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  margin-right: 20px;
}

.el_upload_input {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
}

.single_up_img {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el_upload_sku {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el_upload_sku:hover {
  border-color: #409eff;
}

.el_upload_sku:hover .mask {
  opacity: 1;
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 178px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table {
  border: 1px solid #999;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
}

.el-table table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.el-table thead {
  color: #909399;
  table-layout: fixed;
  border-collapse: separate;
  font-weight: 500;
}

.el-table th,
.el-table tr {
  background: #fff;
}

.el-table .el-table__body td,
.el-table .el-table__header tr th {
  padding: 0;
  background: #f6f7f9;
  border-right: 1px solid #dde5e8;
  border-bottom: 1px solid #dde5e8;
  text-align: center;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.el-table .el-table__header th:first-child div.cell {
  border-left: 0;
  background: #f6f7f9;
  padding: 7px 8px;
  font-weight: 100;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: fixed;
  border-collapse: separate;
}

.el-table th,
.el-table tr {
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
  border-right: 1px solid #dfe6ec;
}

.el-table .el-table__body td div.cell {
  font-size: 12px;
  padding: 9px 8px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.cell .el-input {
  width: 100%;
}

.avatar-box {
  height: 100px;
  width: 100px;
}

.up_img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sbmit_info {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}

#container /deep/ .cost-price input.input-err {
  border: #F56C6C solid 1px;
}

.sku-box {
  background: #F7F9FC;
  width: 500px;
  padding: 20px;
}
</style>
